export default {
  PUSH_ADMIN_DEPARTMENT_VALIDATION_ERRORS: 'PUSH_ADMIN_DEPARTMENT_VALIDATION_ERRORS',
  PUSH_ADMIN_DEPARTMENT: 'PUSH_ADMIN_DEPARTMENT',
  PUSH_ADMIN_DEPARTMENTS: 'PUSH_ADMIN_DEPARTMENTS',
  RESET_ADMIN_DEPARTMENTS_STATE: 'RESET_ADMIN_DEPARTMENT_STATE',
  SET_IS_ADDING_ADMIN_DEPARTMENT: 'SET_IS_ADDING_ADMIN_DEPARTMENT',
  SET_ADMIN_DEPARTMENTS_IS_LOADING: 'SET_ADMIN_DEPARTMENTS_IS_LOADING',
};
